import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Back from "../sections/Back";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import Icon from "../sections/MUI/Icon";
import {toast} from "react-toastify";

class EditService extends Component {

    state = {
        categories: [],
        id: "",
        title: "",
        image: null,
        price: "",
        category: [],
        options: [],
        description: "",
        gadgets: [],

        modalCategory: false,

        option: "",
        gadget: ""
    };

    componentDidMount() {
        config.scrollTop();
        this.getCategories();
        this.getService();
    }

    getCategories() {
        axios.get(`${config.api}/admin/categories?token=${config.token}`)
            .then(r => {
                this.setState({
                    categories: r.data.categories
                });
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    getService() {
        axios.get(`${config.api}/admin/service/single?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                this.setState({...r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }


    renderChildrenCategories(children) {
        return children ? children.length > 0 ?
            <div className="sub-categories">
                {
                    children.map((scat, i) =>
                        <div
                            key={"scat" + i} className="row">
                            <div className="col-auto">
                                <div
                                    style={this.categoryIsSelected(scat._id) ? {
                                        color: "#0a940a",
                                        fontWeight: 600
                                    } : {
                                        color: "#656565",
                                        fontWeight: 500
                                    }}
                                    className="title"
                                    onClick={() => this.handleCategoryClick(scat._id)}>-&nbsp;{scat.title}</div>
                                <div>
                                    {this.renderChildrenCategories(scat.children)}
                                </div>
                            </div>

                        </div>
                    )
                }
            </div> : null : null;

    }


    categoryIsSelected(id) {
        const {category} = this.state;
        return category.includes(id)
    }

    handleCategoryClick(id) {
        let {category} = this.state;
        let isSelected = false;
        category.map((c, i) => {
            if (c === id) {
                isSelected = true;
                category.splice(i, 1);
            }
        })
        if (!isSelected) {
            category.push(id);
        }

        this.setState({category});
    }

    handleOptionChange(index, value) {
        let {options} = this.state;
        options[index] = value;
        this.setState({options});
    }

    handleRemoveOption(index) {
        let {options} = this.state;
        options.splice(index, 1);
        this.setState({options});
    }

    handleAddOption() {
        let {option, options} = this.state;
        options.push(option);

        this.setState({options, option: ""});
    }

    handleGadgetChange(index, value) {
        let {gadgets} = this.state;
        gadgets[index] = value;
        this.setState({gadgets});
    }

    handleRemoveGadget(index) {
        let {gadgets} = this.state;
        gadgets.splice(index, 1);
        this.setState({gadgets});
    }

    handleAddGadget() {
        let {gadget, gadgets} = this.state;
        gadgets.push(gadget);

        this.setState({gadgets, gadget: ""});
    }

    submit() {
        const {
            id,
            title,
            category,
            image,
            price,
            description,
            options,
            gadgets
        } = this.state;
        if (title !== "" && price.toString() !== "" && category.length > 0 && description.toString() !== "") {
            let params = new FormData();
            params.append("id", id);
            params.append("title", title);
            params.append("category", JSON.stringify(category));
            params.append("price", price.toString().replace(/,/g, ""));
            params.append("meta", JSON.stringify({
                description
            }));
            if (image) {
                params.append("image", image);
            }
            params.append("options", JSON.stringify(options));
            params.append("gadgets", JSON.stringify(gadgets));

            toast.info("در حال ویرایش ...")
            axios.put(`${config.api}/admin/service?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقیت ویرایش شد");
                    this.getService();
                })
                .catch(err => {
                    config.handleError(err)
                });

        } else {
            toast.error("همه فیلد ها را تکمیل کنید.")
        }
    }

    delete() {
        const {id} = this.state;
        toast.info("در حال حذف ...")
        axios.delete(`${config.api}/admin/service?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد");
                setTimeout(() => {
                    this.props.navigate(-1);
                }, 1500)
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    render() {
        const {
            categories,
            id,
            title,
            image,
            price,
            description,
            options,
            gadgets,
            modalCategory,
            gadget,
            option
        } = this.state;
        return (
            <div className="edit-service">
                {modalCategory ?
                    <Modal display={modalCategory}
                           zIndex={999999}
                           title="انتخاب دسته بندی"
                           icon="list"
                           onCloseClick={() => this.setState({modalCategory: false})}>
                        <div className="modal-select-categories">
                            {
                                categories ?
                                    categories.length > 0 ?
                                        categories.map((c, i) =>
                                            <div id={"c" + i} className="category" key={"c__" + i}>

                                                <div
                                                    className="title"
                                                    style={this.categoryIsSelected(c._id) ? {
                                                        color: "#0a940a",
                                                        fontWeight: 600
                                                    } : {
                                                        color: "#656565",
                                                        fontWeight: 500
                                                    }}
                                                    onClick={() => this.handleCategoryClick(c._id)}>{c.title}</div>
                                                {
                                                    c.children ? this.renderChildrenCategories(c.children)
                                                        : null
                                                }

                                            </div>
                                        )
                                        : <div>لیست دسته بندی خالی است</div>
                                    : null
                            }
                        </div>
                    </Modal>
                    : null}
                <Back {...this.props}/>
                <div className="info">
                    <div className="row">
                        <div className="col-md-6">
                            <Field name="title"
                                   value={title}
                                   label="عنوان"
                                   maxLength={400}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-6">
                            <File name="image"
                                  value={image}
                                  label="عکس"
                                  multiple={false}
                                  onChange={(name, value) => this.setState({[name]: value})}
                                  accept="image/*"/>
                        </div>
                        <div className="col-md-12">
                            <Field name="price"
                                   value={price}
                                   typePrice={true}
                                   style={{direction: "ltr"}}
                                   label="هزینه هر ساعت خدمت"
                                   maxLength={30}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-12">
                            <Field nam="description"
                                   value={description}
                                   label="توضیحات متا"
                                   row={3}
                                   maxLength={3000}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-md-12">
                            <Button submit={false} icon="list"
                                    onClick={() => this.setState({modalCategory: true})}>انتخاب دسته بندی</Button>
                        </div>
                        <div className="col-md-12">
                            <div>گزینه ها:</div>
                            <div className="row">
                                <div className="col">
                                    <Field name="option"
                                           value={option}
                                           label="گزینه"
                                           maxLength={300}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-auto">
                                    <Icon i="plus" className="add-option-icon"
                                          onClick={() => this.handleAddOption()}/>
                                </div>
                            </div>
                            {
                                options.map((o, i) =>
                                    <div className="row" key={"opt" + i}>
                                        <div className="col">
                                            <Field name="option"
                                                   label="گزینه"
                                                   value={o}
                                                   onChange={(name, value) => this.handleOptionChange(i, value)}/>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="minus" className="remove-option-icon"
                                                  onClick={() => this.handleRemoveOption(i)}/>
                                        </div>
                                    </div>
                                )
                            }

                            <div>ابزار ها:</div>

                            <div className="row">
                                <div className="col">
                                    <Field name="gadget"
                                           value={gadget}
                                           label="ابزار"
                                           maxLength={300}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-auto">
                                    <Icon i="plus" className="add-gadget-icon"
                                          onClick={() => this.handleAddGadget()}/>
                                </div>
                            </div>
                            {
                                gadgets.map((o, i) =>
                                    <div className="row" key={"opt" + i}>
                                        <div className="col">
                                            <Field name="gadget"
                                                   label="ابزار"
                                                   value={o}
                                                   onChange={(name, value) => this.handleGadgetChange(i, value)}/>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="minus" className="remove-option-icon"
                                                  onClick={() => this.handleRemoveGadget(i)}/>
                                        </div>
                                    </div>
                                )
                            }

                            <div className="row justify-content-between">
                                <div className="col-md-5">
                                    <Button submit={false} icon="edit" onClick={() => this.submit()}>ویرایش
                                        کردن</Button>
                                </div>
                                <div className="col-md-5">
                                    <Button submit={false} icon="trash"
                                            backgroundColor="#E53935"
                                            onDoubleClick={() => this.delete()}>حذف کردن (دوبار کلیک)</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(EditService);